import { LuUser2 } from 'react-icons/lu';
import { MdOutlineAttachFile } from 'react-icons/md';

import { IDocument } from '@/interfaces/entities/therapist';
import { IUser } from '@/interfaces/entities/user';

export default function TherapistSection({ user }: { user: IUser }) {
	return (
		<div className="mt-4">
			<hr className="mt-4 mb-4 border-t-2 border-gray-300" />
			<h2 className="text-2xl font-bold mb-4">Health Professional Info</h2>
			<div>
				<p className="font-bold">Biography </p>
				{user.therapist.biography ?? '---'}
			</div>
			<div>
				<p className="font-bold">Services</p>
				{user.therapist.services ?? '---'}
			</div>
			<div className="overflow-auto w-full h-48 bg-neutral-100 mt-2 p-2 rounded-md">
				<div className="">
					<b>Documents:</b>
					<ul>
						{user.therapist.documents && user.therapist.documents.length > 0 ? (
							user.therapist.documents.map((document: IDocument) => (
								<li key={document.id}>
									<a href={document.url} target="_blank">
										<div className="flex flex-row items-center">
											<MdOutlineAttachFile />
											<div className="text-blue-500 ml-1">
												{upperCaseFirstLetter(document.title)}
											</div>
										</div>
									</a>
								</li>
							))
						) : (
							<p>---</p>
						)}
					</ul>
				</div>

				<div>
					<b>Patients:</b>
					<ul className="">
						{user.therapist.patients &&
							user.therapist.patients.length > 0 &&
							user.therapist.patients.map((patient: IUser) => (
								<li key={patient.id}>
									<LuUser2 /> {patient.firstName} {patient.lastName} (Id:{' '}
									{patient.id})
								</li>
							))}
					</ul>
				</div>
			</div>
		</div>
	);
}

const upperCaseFirstLetter = (word: string) => {
	return word.charAt(0).toUpperCase() + word.slice(1);
};
